/**
 * PDF.js Worker Setup
 *
 * Sets the worker source using pdfjs-dist directly (not react-pdf)
 * to avoid react-pdf's side-effect that overwrites workerSrc with
 * a bare module specifier that browsers can't resolve.
 *
 * Import this module before any PDF operations.
 */

// Must precede the pdfjs-dist import: pdf.js calls Promise.withResolvers, which
// Chrome/Edge 109 (Windows 8.1's terminal version) does not have. The worker gets
// the same fallback via pdf.worker.shim.mjs; this one covers the main-thread lib
// and pdf.js's fake-worker path, which runs worker code on the main thread.
import "./promise-with-resolvers";

import * as pdfjs from "pdfjs-dist";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf-worker/pdf.worker.shim.mjs";
